import {useSelector} from "react-redux";
import React from "react";
import Slider from "../../components/Slider/Slider";
import Tabs from "../../components/Tabs/Tabs";
import {TABS} from "../../../constants/index.jsx";

const PageWrapper = function ({children}) {
    const isMobile = useSelector(state => state.user.isMobile);
    const activePage = useSelector(state => state.lobby.activePage);
    return (
        (isMobile) ? (
            <div className="mobile-content">
                {
                    !["History"].includes(activePage) && <>
                        <Slider/>
                        <Tabs tabItems={TABS}/>
                    </>
                }
                <>{children}</>
            </div>
        ) : (
            <>{children}</>
        )
    );
};

export default PageWrapper;
